import React from "react";

function Works() {
  return (
    <div className="pt-8 pb-8" id="works">
      <div className="container mx-auto">
        <h4 className="text-2xl text-black font-semibold">Checkout my Works</h4>
        <div className="flex flex-col lg:flex-row p-8">
          <div className="w-full lg:w-1/2 p-3">
            <div className="flex flex-col lg:flex-row rounded overflow-hidden h-auto lg:h-64 border shadow-lg">
              <img
                className="block w-full lg:w-64 flex-none bg-cover lg:h-64 lg:48"
                src="https://res.cloudinary.com/vivekiscoding/image/upload/v1667327827/vivekanand/images/weatherProject.png"
                alt="weather-project"
              />
              <div className="bg-zinc-500 rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                <div className="text-white font-bold text-xl mb-2 leading-tight">
                  This is a weather web-app, where user can check the current
                  weather by specifying the location.
                </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-1/2 p-3">
            <div className="flex flex-col lg:flex-row-reverse rounded overflow-hidden h-auto lg:h-64 border shadow-lg">
              <img
                className="block w-full lg:w-64 flex-none bg-cover lg:h-64 h-48"
                src="https://res.cloudinary.com/vivekiscoding/image/upload/v1667327826/vivekanand/images/covid19Project.png"
                alt="covid-19"
              />
              <div className="bg-zinc-500 rounded-b lg:rounded-b-none lg:rounded-r p-4 flex flex-col justify-between leading-normal">
                <div className="text-white font-bold text-xl mb-2 leading-tight">
                  Live data of covid-19 in India provided from various apis.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Works;
